import React from "react";
import { Spin, Row, Col, Radio } from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "./Filters";
import KpiCard from "./KpiCard";
import ChartPanel from "./ChartPanel";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import GraficoTopClientes from "./GraficoTopClientes";
import GraficoEvolucionClientes from "./GraficoEvolucionClientes";
import GraficoRangoClientes from "./GraficoRangoClientes";
import { buildDashboardData, formatCurrency, formatNumber } from "./utils";
import "./styles.css";
import comprobanteService from "../../../service/ventas/comprobanteService";

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.state = {
            loading: true,
            moneda: "PEN",
            anios: anioMock.values,
            meses: mesMock.values,
            filter,
            dashboard: buildDashboardData(null, filter),
        };
    }

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeMoneda = (e) => {
        this.setState({ moneda: e.target.value });
    };

    handleClearFilters = () => {
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.setState({ filter, moneda: "PEN" });
        this.handleGenerateReport(filter);
    };

    handleGenerateReport = async (filter) => {
        this.setState({ loading: true });
        const response = await comprobanteService.dashboardCliente(filter);

        this.setState({
            dashboard: buildDashboardData(response, filter),
            loading: false,
        });
    };

    async componentDidMount() {
        await this.handleGenerateReport(this.state.filter);
    }

    render() {
        const { moneda, filter } = this.state;
        const { kpis, topClientes, evolucion, rangoClientes } = this.state.dashboard;
        const clave = moneda === "USD" ? "usd" : "pen";
        const esMismoMes = filter.anioInicio === filter.anioFin && filter.mesInicio === filter.mesFin;
        const tituloEvolucion = `Ventas por Cliente (Evolución ${esMismoMes ? "diaria" : "mensual"})`;

        return (
            <div>
                <Header
                    title="Dashboard de Ventas por Cliente"
                    onClearFilters={this.handleClearFilters}
                    onSearch={() => this.handleGenerateReport(this.state.filter)}
                />
                <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
                <div className="moneda-toggle">
                    <Radio.Group value={moneda} onChange={this.handleChangeMoneda} buttonStyle="solid">
                        <Radio.Button value="PEN">S/ Soles</Radio.Button>
                        <Radio.Button value="USD">US$ Dólares</Radio.Button>
                    </Radio.Group>
                </div>
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <div className="kpi-row">
                        <KpiCard
                            icon="team"
                            iconColor="#2563eb"
                            iconBackground="#dbeafe"
                            label="Total Ventas (Periodo)"
                            value={formatCurrency(kpis.totalVentas[clave].valor, moneda)}
                            tendenciaDireccion={kpis.totalVentas[clave].tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.totalVentas[clave].tendenciaPct)}% vs período anterior`}
                        />
                        <KpiCard
                            icon="user-add"
                            iconColor="#16a34a"
                            iconBackground="#dcfce7"
                            label="Clientes"
                            value={kpis.clientes.valor}
                            tendenciaDireccion={kpis.clientes.tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.clientes.tendenciaPct)}% vs período anterior`}
                        />
                        <KpiCard
                            icon="file-text"
                            iconColor="#7c3aed"
                            iconBackground="#ede9fe"
                            label="Comprobantes"
                            value={kpis.comprobantes.valor}
                            tendenciaDireccion={kpis.comprobantes.tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.comprobantes.tendenciaPct)}% vs período anterior`}
                        />
                        <KpiCard
                            icon="usergroup-add"
                            iconColor="#ea580c"
                            iconBackground="#ffedd5"
                            label="Clientes Nuevos"
                            value={kpis.clientesNuevos.valor}
                            tendenciaDireccion={kpis.clientesNuevos.tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.clientesNuevos.tendenciaPct)}% vs período anterior`}
                        />
                        <KpiCard
                            icon="percentage"
                            iconColor="#dc2626"
                            iconBackground="#fee2e2"
                            label="% Concentración Top 10"
                            value={`${formatNumber(kpis.concentracionTop10[clave].valor)}%`}
                            tendenciaDireccion={kpis.concentracionTop10[clave].tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.concentracionTop10[clave].tendenciaPct)} p.p. vs período anterior`}
                        />
                    </div>

                    <Row gutter={16}>
                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Ventas por Cliente (Top 10)">
                                <GraficoTopClientes
                                    clientes={topClientes.map((item) => item.nombre)}
                                    valores={topClientes.map((item) => item[clave])}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Ventas por Rango de Clientes">
                                <GraficoRangoClientes datos={rangoClientes[clave]} moneda={moneda} />
                            </ChartPanel>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <ChartPanel title={tituloEvolucion} selectLabel="Este mes">
                                <GraficoEvolucionClientes
                                    timeLine={evolucion.timeLine}
                                    series={evolucion[clave]}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>
                    </Row>
                </Spin>
            </div>
        );
    }
}
